import React from 'react';

// The single source of truth for the password policy - the validator, the requirements
// copy, and the signup criteria checklist are all derived from this list
export const passwordRules: { label: string; test: (password: string) => boolean }[] = [
  { label: 'Must be at least 8 characters long', test: password => password.length >= 8 },
  { label: 'Must contain at least one lowercase letter', test: password => /[a-z]/.test(password) },
  { label: 'Must contain at least one uppercase letter', test: password => /[A-Z]/.test(password) },
  { label: 'Must contain at least one number', test: password => /[0-9]/.test(password) },
];

export const passwordRequirements = passwordRules.map(rule => rule.label);

export function validatePassword(password: string) {
  return passwordRules.every(rule => rule.test(password));
}

export function PasswordValidationMessage({ password }: { password: string }) {
  return (
    <ul className="tw:text-xs tw:text-red-500" data-testid="passwordValidationMessage">
      {passwordRules
        .filter(rule => !rule.test(password))
        .map(rule => (
          <li key={rule.label}>{rule.label}</li>
        ))}
    </ul>
  );
}

export function PasswordMatchErrorMessage() {
  return (
    <p className="tw:text-xs tw:text-red-500" data-testid="passwordsMatchError">
      Passwords do not match
    </p>
  );
}

export function PasswordsUniqueErrorMessage() {
  return (
    <p className="tw:mt-2 tw:text-xs tw:text-red-500" data-testid="passwordsUniqueError">
      New password must be different from your previous password
    </p>
  );
}

export function ChangePasswordErrorMessage({ errorMessage }: { errorMessage: string }) {
  return (
    <p className="tw:mt-2 tw:text-xs tw:text-red-500" data-testid="changePasswordError">
      {errorMessage}
    </p>
  );
}
